import NewModel from './NewModelContainer';

export default NewModel;
